import { render, staticRenderFns } from "./comentarios-ajuste.vue?vue&type=template&id=fe0fba98&"
import script from "./comentarios-ajuste.component.ts?vue&type=script&lang=ts&"
export * from "./comentarios-ajuste.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports